import { createFileRoute } from '@tanstack/react-router';
import { RecurrenceForm } from '@/pages/forecast/recurrences/form/recurrence-form';
import { PROTECTED, FORECAST } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${FORECAST}`;

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/recurrences/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditRecurrenceModal,
});

function EditRecurrenceModal() {
  const { id } = Route.useParams();
  return <RecurrenceForm id={id} returnUrl={RETURN_URL} />;
}
